import io from "socket.io-client";
import { useEffect, useState } from "react";

//const socket_ip = "http://localhost:8095/" // local debug 
const socket_ip = "https://qrtest.zeniq.dev/" // production

export const useSocket = ({ testcase }) => {

    const [socket, setSocket] = useState(null);
    const [socketResponsesScan, setSocketResponsesScan] = useState()
    const [socketResponsesExecute, setSocketResponsesExecute] = useState()
    const [socketResponses, setSocketResponses] = useState({})
    const [qrLink, setQRLink] = useState('no connection')

    useEffect(() => {
        if (!socket) {
            const newSocket = io(socket_ip);
            setSocket(newSocket);
        }

        return () => {
            socket &&
                socket.disconnect();
        };
    }, []);

    useEffect(() => {
        setSocketResponses({
            scanned: socketResponsesScan,
            confirmed: socketResponsesExecute
        })
    }, [socketResponsesExecute, socketResponsesScan]);

    useEffect(() => {
        if (socket) {
            socket.on("connect", () => {
                console.log("connected");
            });

            socket.on("disconnect", () => {
                console.log("disconnected");
            });

            socket.emit("gen_qr_" + testcase.name, () => {
                console.log("gen_qr_", testcase.name);
            });


            socket.on("qr_" + testcase.name, data => {
                console.log("qr_", testcase.name);
                setQRLink(data)
            });

            socket.on("scan_" + testcase.name, data => {
                console.log(testcase.name + '_scan:', data)
                setSocketResponsesScan(Object.fromEntries(Object.entries(data).filter(([_, v]) => v != null)))
            });

            socket.on("execute_" + testcase.name, data => {
                console.log(testcase.name + '_execute:', data)
                setSocketResponsesExecute(Object.fromEntries(Object.entries(data).filter(([_, v]) => v != null)))
            });
        }
    }, [socket]);

    return { socket, socketResponses, qrLink }
}